import { stats } from '@/mocks/homeData';

export default function StatsSection() {
  return (
    <section className="relative w-full py-14 md:py-16 bg-primary-600">
      <div className="absolute inset-0 bg-gradient-to-r from-primary-700/30 via-transparent to-primary-700/30"></div>
      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center">
              <p className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-2 tracking-tight">
                {stat.value}
              </p>
              <p className="text-sm md:text-base text-background-200 font-medium">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}